<div class="absolute top-0 left-0 h-full w-full">
    <div class="bg-[rgba(242,242,242,1)] h-screen overflow-hidden w-full">
        <div class="h-full max-h-full grid lg:grid-cols-[minmax(0,300px)_minmax(0,1fr)] w-full overflow-hidden">
            <app-sidebar [products]="products"></app-sidebar>

            <div class="h-full relative block w-full overflow-hidden">
                <div class="w-full h-full overflow-hidden relative z-[2]">
                    <div class="h-full w-full max-w-full relative grid grid-rows-[min-content_1fr] overflow-hidden">
                        <app-header></app-header>

                        <div class="h-full w-full overflow-hidden">
                            <div class="content_scroll-site min-h-full w-100% h-auto grid grid-cols-[100%] grid-rows-[1fr_min-content] overflow-x-hidden overflow-y-auto max-w-full max-h-full">
                                <div class="lg:px-5 px-3 w-full">

                                    <!-- <div class="max-w-full block mx-auto">
                                        <div id="alert" class="alert font__title alert-danger">Mensaje de error</div>
                                        <div id="alert" class="alert font__title alert-success">Mensaje de satisfacción</div>
                                    </div> -->

                                    <div class="py-5 w-full">
                                        <router-outlet></router-outlet>
                                    </div>
                                </div>

                                <app-footer [title]="'QHANTUY LLC'"></app-footer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
